import React from 'react';
import './App.css';

function AffiliateDisclosure(props) {
	return (
		<React.Fragment>
			<h4>Affiliate Disclosure</h4>
			<p>Rosaceafedup is a participant in the Amazon Services LLC Associates Program. The LLC Associates Program provides a means for websites to earn fees by linking to amazon.com. All buttons labeled "Shop now" are affiliate links. We make commissions on purchases made after using these links.
			</p>
			<p>Prices are exactly the same if you purchase through an affiliate link or non-affiliate link. You will not pay more by using our affiliate links. If you wish to opt out of using the affiliate links, you may search for the product directly on Amazon rather than using our links.</p>
		</React.Fragment>
	);
}

export default AffiliateDisclosure;



// WEBPACK FOOTER //
// ./src/AffiliateDisclosure.jsx